var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallblob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 207.073,
    height: 216.137,
    viewBox: "0 0 207.073 216.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M142.144,20.008c13.48,14.565,18.655,36.349,16.579,56.027s-11.435,37.279-24.915,56.647-31.081,40.5-49.272,41.091S47.568,154.4,30.8,135.037C14.007,115.669-.774,96.89.031,78.948.868,61.006,17.323,43.869,34.088,29.3,50.883,14.74,68.02,2.748,87.45.423s41.215,5.02,54.695,19.585",
    transform: "matrix(-0.946, 0.326, -0.326, -0.946, 207.073, 164.317)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallblob1);
export default __webpack_public_path__ + "static/media/smallblob1.063b9f8df256789732a9c668a00ae558.svg";
export { ForwardRef as ReactComponent };